import React from "react";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export const GlobalAccessCheckbox = ({ value, onChange, readonly = false }) => (
  <div>
    {isCurrentUserSuperAdmin() && (
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            onChange={event => onChange(event.target.checked)}
            disabled={readonly}
          />
        }
        label="Global Access"
      />
    )}
  </div>
);
